export const VERIFY_COMPANY_OUTCOMES = [
  "claim_company",
  "answer_on_behalf",
  "not_related",
] as const

export type VerifyCompanyOutcome = (typeof VERIFY_COMPANY_OUTCOMES)[number]

export const DEFAULT_VERIFY_COMPANY_OUTCOME: VerifyCompanyOutcome =
  VERIFY_COMPANY_OUTCOMES[0]

export type InvitedCompanySummary = Readonly<{
  name: string
  street: string
  city: string
  country: string
}>

export type UseVerifyCompanyOutcomeStepResult = Readonly<{
  invitedCompany: InvitedCompanySummary
  selectedOutcome: VerifyCompanyOutcome
  selectOutcome: (outcome: VerifyCompanyOutcome) => void
  handleContinue: () => boolean
}>
